import styled from 'styled-components';

const FormulaValue = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.fontSize && `
    font-size: ${p.fontSize};
  `}

  span.divider {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 27, 59, 0.94);
    margin: 13px 0 13px -5px;
    width: calc(100% + 10px);
  }

  b, .negative-value {
    color: #EC5E59;
  }
`;

export default FormulaValue;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/formula-value.js